var _linearGradient;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconStats = function SvgIconStats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "nav-icon",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132790891467352523000000006147507111050949288_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 34.2707,
    x2: 17.5,
    y2: 0.7293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    className: "icon-gradient-bottom"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    className: "icon-gradient-top"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132790891467352523000000006147507111050949288_)"
    },
    d: "M6.8,34.3H0.6V18.7h6.2V34.3z M16,0.7H9.8     v33.5H16V0.7z M25.2,8.4H19v25.9h6.2V8.4z M34.4,14.1h-6.2v20.2h6.2V14.1z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-stats.667727e8.svg";
export { ForwardRef as ReactComponent };